import React from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { UserProvider } from '../core/context/user';
import SignInPage from './signIn';
import Error404 from './errorPages/Error404';
import Error500 from './errorPages/Error500';
import DefaultLayout from './layout/index';
import CompleteProfilePage from './customer/completeProfile';
import ForgetPasswordPage from './forget-password';
import ResetPasswordPage from './reset-password';
import { ConfigProvider } from 'antd';

// Jira-achtige tokens voor antd (tabellen, paginering, selects): zelfde
// blauw, radius en lettertype als de rest van de app.
const ANTD_THEME = {
  token: {
    colorPrimary: '#0C66E4',
    colorLink: '#0C66E4',
    colorText: '#172B4D',
    colorTextSecondary: '#626F86',
    colorBorder: '#DCDFE4',
    colorBorderSecondary: '#DCDFE4',
    borderRadius: 3,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 14,
  },
  components: {
    Table: {
      headerBg: '#F7F8F9',
      headerColor: '#626F86',
      rowHoverBg: '#F7F8F9',
      borderColor: '#DCDFE4',
      cellPaddingBlock: 10,
    },
  },
};

export default function App() {
  const location = useLocation();
  document.documentElement.setAttribute('data-theme', 'light');
  return (
    <ConfigProvider theme={ANTD_THEME}>
    <UserProvider>
      <Routes>
        {/* Redirect from root path */}
        <Route path="/" element={<Navigate to="/signIn" />} />
        
        {/* Authentication and Error Routes */}
        <Route path="/signIn" element={<SignInPage />} />
        <Route path="/forget-password" element={<ForgetPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/complete-profile/:token" element={<CompleteProfilePage />} />
        <Route path="/error-404" element={<Error404 />} />
        <Route path="/error-500" element={<Error500 />} />
        
        {/* Protected Routes */}
        <Route path="/panel/*" element={<DefaultLayout />} />
        
        {/* Catch-all route for undefined paths */}
        <Route path="*" element={<Navigate to="/error-404" replace />} />
      </Routes>
    </UserProvider>
    </ConfigProvider>
  );
}
